import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../core/authentication/auth.service';
import { Router } from '@angular/router';
import { first, tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { CryptoService } from '../core/services/crypto.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-ay-login',
  templateUrl: './ay-login.component.html',
  styleUrls: ['./ay-login.component.scss']
})
export class AyLoginComponent implements OnInit {

  public loginForm: UntypedFormGroup;
  public submitted: boolean;
  public errorLogin: string;
  brand: string;
  isTrainingEnv: boolean;
  isLoading: boolean;
  showPassword = false;
  private cookieName = 'ayCarLPdata';

  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService,
    private cryptoService: CryptoService
  ) {
    this.brand = environment.brand;
    this.isTrainingEnv = environment.isTrainingEnv;
  }

  get f() {
    return this.loginForm.controls;
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {

    let login = '', pswd = '';
    const cookieValue = this.cookieService.get(this.cookieName);
    if (cookieValue) {
      try {
        const data = this.cryptoService.dec(cookieValue, true)
        login = data['l'];
        pswd = data['p'];
      }
      catch {
        this.cookieService.delete(this.cookieName);
      }
    }

    this.loginForm = this.fb.group({
      username: [login, { validators: [Validators.required] }],
      password: [pswd, { validators: [Validators.required] }],
      remindMe: [true]
    });
  }

  onSubmit() {
    this.errorLogin = null;
    this.submitted = true;

    if (this.loginForm.invalid) {
      return false;
    }

    this.isLoading = true;
    this.authService.login(this.loginForm.value.username, this.loginForm.value.password)
      .pipe(tap( () => this.isLoading = false), first())
      .subscribe({
        next:
          () => {
            this.storeInfo();
            this.router.navigate(['/dispatch-profile']);
          },
        error: () => {
          this.errorLogin = "failed";
          this.isLoading = false;
        }
      });
  }

  onPasswordRemind(){
    this.router.navigate(['./selfCareCenter/passwordChangeRequest']);
  }

  storeInfo() {
    const data = { l: this.loginForm.value.username, p: this.loginForm.value.password };
    if (this.loginForm.value.remindMe) {
      this.cookieService.set(this.cookieName, this.cryptoService.enc(data, true))
    }
    else {
      this.cookieService.delete(this.cookieName);
    }
  }

}
